import {
  updateTaxonomyBenchmark
} from '../../services/apis'
import {
  hasError,
  isServerResponseError,
} from '../common'

const updateTaxonomyBenchmarkData = async (id, data) => {
  const response = await updateTaxonomyBenchmark(id, data)
  return isServerResponseError(response) || hasError(response)
    ? 'failed'
    : 'success'
}

export default updateTaxonomyBenchmarkData
